// ** Router Import
import Router from './router/Router'
import axios from "axios"


// @todo deploy
// axios.defaults.baseURL = 'http://localhost:4000'

const App = props => <Router />

export default App
